// extracted by mini-css-extract-plugin
export var alertIcon = "_np-0";